interface BroadcastEmailDetailsInput {
	canUseEmail: boolean
	hasFromAddress: boolean
}

export function showsBroadcastEmailDetails({
	canUseEmail,
	hasFromAddress,
}: BroadcastEmailDetailsInput): boolean {
	return canUseEmail && hasFromAddress
}
